import React, { useState, useEffect, useRef } from 'react';

function getProgress(secondsLeft, totalSeconds) {
  return 1 - secondsLeft / totalSeconds;
}

export default function Timer({ targetSeconds, onComplete, onStop }) {
  const [secondsLeft, setSecondsLeft] = useState(targetSeconds);
  const audioRef = useRef();
  const totalSeconds = targetSeconds;
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    setSecondsLeft(targetSeconds);
    setIsFinished(false);
  }, [targetSeconds]);

  useEffect(() => {
    if (secondsLeft <= 0) {
      audioRef.current && audioRef.current.play();
      setIsFinished(true);
      onComplete && onComplete();
      return;
    }
    const timer = setInterval(() => setSecondsLeft(s => s - 1), 1000);
    return () => clearInterval(timer);
  }, [secondsLeft, onComplete]);

  const min = Math.floor(secondsLeft / 60);
  const sec = String(secondsLeft % 60).padStart(2, '0');
  const progress = getProgress(secondsLeft, totalSeconds);
  const radius = 80;
  const stroke = 8;
  const normalizedRadius = radius - stroke / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference * (1 - progress);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '32px 0' }}>
      <svg height={radius * 2} width={radius * 2} style={{ marginBottom: 8 }}>
        <circle
          stroke="#eee"
          fill="none"
          strokeWidth={stroke}
          cx={radius}
          cy={radius}
          r={normalizedRadius}
        />
        <circle
          stroke="#2d7d46"
          fill="none"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference + ' ' + circumference}
          style={{ strokeDashoffset, transition: 'stroke-dashoffset 1s linear' }}
          cx={radius}
          cy={radius}
          r={normalizedRadius}
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dy=".3em"
          fontSize="2.2em"
          fill="#222"
        >
          {min}:{sec}
        </text>
      </svg>
      <audio ref={audioRef} src="/ding.mp3" preload="auto" />
      <button
        onClick={onStop}
        style={{ marginTop: 16, padding: '8px 24px', borderRadius: 6, background: '#2d7d46', color: '#fff', border: 'none', fontWeight: 600, fontSize: '1em', cursor: 'pointer' }}
        disabled={isFinished}
      >
        Stop
      </button>
    </div>
  );
}
